import { JSXElementConstructor, ReactElement } from "react";
import { isReactElement } from "./isReactElement";

export const isReactComponent = <P extends any>(value: any): value is ReactElement<P, JSXElementConstructor<any>> =>
    isReactElement(value)
    && typeof value.type === "function"
;